import PostcodeForm from './components/postcode/PostcodeForm';
import { initializeEventTracking } from './utils/gtmTrackerHelper';

function App() {
  initializeEventTracking();
  return (
    <div id='newCalc' className="newCalc pcc-wrap calc-widget">
      <PostcodeForm />
    </div>
  );
}

export default App;
